import moment from 'moment';

import { DetailedAccount } from '../../models/crm/types';
import { isUsableAccountStatus } from '../../util/account-helpers';
import { NullableString } from '../../util/types';

export type AccountUsability = {
  account: DetailedAccount;
  isExpired: boolean;
  isFinished: boolean;
};

export const isAccountUsable = ({ account, isExpired, isFinished }: AccountUsability): boolean =>
  isUsableAccountStatus(account.account_status) && !isExpired && !isFinished;

export const hasAnyUsableAccount = (accounts: AccountUsability[]): boolean =>
  accounts.some(isAccountUsable);

export const toExpirationMoment = (expirationDate: NullableString): NullableString =>
  (expirationDate ? `${expirationDate}T23:59:59Z` : undefined);

export const isExpirationPassed = (expirationDate: NullableString): boolean => {
  const expiresAt = toExpirationMoment(expirationDate);

  if (!expiresAt) {
    return false;
  }

  return moment(expiresAt).diff(moment().utc()) <= 0;
};
